import PartnerBlock from './PartnerBlock';

export default PartnerBlock;
